__webpack_require__.p = "https://order-details.qa.core-artifacts.com/static/";